// extracted by mini-css-extract-plugin
export default {"WarningContents":"WarningModalContent_WarningContents__UEG+b","warning":"WarningModalContent_warning__cuGMU","BackButton":"WarningModalContent_BackButton__noUDy"};